import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const SignInForm = () => {

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [errText, setErrText] = useState("")

  const handleSubmit = (e) => {

  }

  return (<>
    <Form onSubmit={(e) => handleSubmit(e)} className='pt-4 w-100 m-auto'>
      <Form.Group className="mb-3" controlId="formEmail">
        <Form.Label>Email Address</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setEmail(e.target.value)} required type="email" placeholder="Enter Email" />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setPassword(e.target.value)} required type="password" placeholder="" />
      </Form.Group>
      <p className='text-danger' id="sign-in-error-text">{errText}</p>
      <Button disabled={email===""||password===""} className='py-2 w-100 px-5 mt-3 fs-4' variant="outline-dark" type="submit">
        Submit
      </Button>
    </Form>
    <p className='mt-4 text-black-50' style={{fontSize: "1.2rem"}}>Don't you have an account?<Link to="/sign-up" className='text-decoration-none h-t-turquoise text-black'> Sign up here</Link> and get shopping!</p>
  </>)
}

export default SignInForm